<template>
  <layout-bigscreen nav_top="0">
    <div id="antdVue" ref="antdVue" :style="themeColorInit(themeColorConfig)" class="zoom_bg_color" style="width:100%; height:100%;">
      <div class="antdVue" :style="{...calculateStyles}">

        <div class="flex flex-direction justify-center benben-flex-layout yujianjingyingshujudaping_981_random_flex_0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100">
          <div class="flex flex-wrap align-center justify-center yujianjingyingshujudaping_683_fd0_0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100 f-c-3 position-relative bg-size-auto">
            <div class="flex  flex-wrap align-center yujianjingyingshujudaping_883_fd0_0_c0 position-absolute">
              <img class='yujianjingyingshujudaping_425_fd0_0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/03e56738af5b3ecc593d3c6c58203cc6.png" />
              <span class="yujianjingyingshujudaping_796_fd0_0_c0_c1 t-20 t-w-4">多云</span>
              <div class="flex  flex-wrap align-center yujianjingyingshujudaping_340_fd0_0_c0_c2 bg-size-auto">

              </div>
              <span class="yujianjingyingshujudaping_651_fd0_0_c0_c3 t-20 h-10-px t-w-4">6</span>
              <span class="yujianjingyingshujudaping_651_fd0_0_c0_c3 t-20 h-10-px t-w-4">℃</span>

            </div>
            <img class='yujianjingyingshujudaping_976_fd0_0_c1' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/e86a55b2a20775c71c1fb6cc91dd3c1e.png" />
            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">数据大屏</span>
            <img class='yujianjingyingshujudaping_135_fd0_0_c3' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/d3adc8fbbce7c9aa2bbd0f8ae8ac5a40.png" />
            <div class="flex align-center yujianjingyingshujudaping_608_fd0_0_c4 position-absolute">
              <img class='yujianjingyingshujudaping_573_fd0_0_c4_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/2af63761ef0068fdbbfded13de1d740c.png" />

              <benben-real-time class='flex align-center justify-center yujianjingyingshujudaping_600_random_fd0_0_c4_c1 t-18 t-w-4' format="YYYY-MM-DD HH:mm:ss" :has_week="true" :refresh_interval="500" show_title="true" title_position="left" title_name="标题">

              </benben-real-time>


            </div>

            <benben-full-screen class='flex align-center justify-center yujianjingyingshujudaping_370_random_fd0_0_c5 position-absolute a'>

            </benben-full-screen>


          </div>

          <a-row class="benben-grid   w-100" :gutter="[20,8]" type="flex">

            <a-col :xs="24" :md="6" :xl="6" :xxl="6">
              <div class="flex  flex-wrap align-center yujianjingyingshujudaping_221_fd0_1_c0_c0 w-100">
                <div class="flex flex-direction align-start yujianjingyingshujudaping_621_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bdr-16 position-relative">
                  <div class="flex flex-direction flex-wrap align-start  w-100">
                    <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                      <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">店铺订单数量排行</span>

                    </div>
                    <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png" />

                  </div>
                  <div class="flex  flex-wrap align-center  w-100 h-100">

                    <benben-bar-cross class='w-100 h-100' :field-options="field_options_377306" data_source_type="1" chart_show_type="bar-cross" show_title="false" title_position="left" title_name="标题" :is_morcolor="false" :theme_color="theme_color_9213" :chart-option="chartOptions_random_8300">

                    </benben-bar-cross>


                  </div>

                </div>
                <div class="flex flex-direction align-start yujianjingyingshujudaping_621_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bdr-16 position-relative">
                  <div class="flex flex-direction flex-wrap align-start  w-100">
                    <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                      <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">店铺销售额排行</span>

                    </div>
                    <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png" />

                  </div>
                  <div class="flex align-center  w-100 h-100">
                    <div class="flex align-center  w-100 h-100">

                      <benben-bar-cross class='w-100 h-100' :field-options="field_options_602307" data_source_type="1" chart_show_type="bar-cross" show_title="false" title_position="left" title_name="标题" :is_morcolor="false" :theme_color="theme_color_7163" :chart-option="chartOptions_random_5150">

                      </benben-bar-cross>


                    </div>

                  </div>

                </div>
                <div class="flex flex-direction align-start yujianjingyingshujudaping_621_fd0_1_c0_c0_c0 w-100 bdr-16 position-relative">
                  <div class="flex flex-direction flex-wrap align-start  w-100">
                    <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                      <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">接单订单列表</span>

                    </div>
                    <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png" />

                  </div>

                  <big-screen-table class='w-100 h-100' :field-options="field_options_947098" data_source_type="1" chart_show_type="big_screen_table" show_title="false" title_position="left" title_name="标题" :show_num="4" play_type="one_num" num_width="10" num_shape="circle" num_name="序号" num_top="3" :show_sort="true" sort_order="desc" sort_field="create_time">

                  </big-screen-table>


                </div>

              </div>

            </a-col>


            <a-col :xs="24" :md="12" :xl="12" :xxl="12">
              <div class="flex  flex-wrap align-center yujianjingyingshujudaping_221_fd0_1_c0_c0 w-100">
                <div class="flex flex-direction align-start yujianjingyingshujudaping_999_fd0_1_c1_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bdr-16 position-relative">

                  <big-screen-time-filter class='flex align-center yujianjingyingshujudaping_979_random_fd0_1_c1_c0_c0_c0'>
                    <template v-slot:btn="{title}">
                      <div class="flex align-center self-center justify-center  f-c-fff t-16 h-100">
                        <span class="yujianjingyingshujudaping_856_fd0_1_c1_c0_c0_c0_c0_c0">全部</span>
                        <img class='yujianjingyingshujudaping_820_fd0_1_c1_c0_c0_c0_c0_c1' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240102/26a979bc0700aa1ecef634876f62c263.png" />

                      </div>
                    </template>
                    <template v-slot:active="{title}">
                      <div class="flex align-center self-center justify-center  f-c-fff t-16 h-100">
                        <span class="yujianjingyingshujudaping_856_fd0_1_c1_c0_c0_c0_c0_c0">全部</span>
                        <img class='yujianjingyingshujudaping_820_fd0_1_c1_c0_c0_c0_c0_c1' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240102/26a979bc0700aa1ecef634876f62c263.png" />

                      </div>
                    </template>

                  </big-screen-time-filter>

                  <div class="flex align-center justify-between yujianjingyingshujudaping_141_fd0_1_c1_c0_c0_c1 w-100">
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">支付单量</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 lh-32-px' :field-options="field_options_803063" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">接单成功次数</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 lh-32-px' :field-options="field_options_988847" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">服务完成次数</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 lh-32-px' :field-options="field_options_953521" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>


                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">完成总金额</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 f-c-9 lh-32-px' :field-options="field_options_965623" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">一口价金额</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 f-c-9 lh-32-px' :field-options="field_options_788678" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>

                  </div>
                  <div class="flex align-center justify-between yujianjingyingshujudaping_141_fd0_1_c1_c0_c0_c1 w-100">
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">议价定金金额</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 lh-32-px' :field-options="field_options_310893" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">议价报价金额</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 lh-32-px' :field-options="field_options_936238" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">竞价支付金额</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 lh-32-px' :field-options="field_options_571671" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">加价支付金额</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 f-c-9 lh-32-px' :field-options="field_options_984204" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 h-100 bg-size-auto">
                      <span class="yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 lh-24-px f-c-fff t-16 t-w-5">单均价</span>
                      <div class="flex flex-wrap align-end  f-c-9">

                        <benben-light-text class='light-text yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-20 f-c-9 lh-32-px' :field-options="field_options_494928" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                        </benben-light-text>

                        <span class="yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 lh-24-px t-20 t-w-5">
                                                </span>

                      </div>

                    </div>

                  </div>
                  <div class="flex align-start  w-100">

                    <a-row class="benben-grid   w-100" :gutter="[8,8]" type="flex">

                      <a-col :xs="24" :md="12" :xl="6" :xxl="6">

                        <benben-pie-ring class='yujianjingyingshujudaping_651_random_fd0_1_c1_c0_c0_c3_c0_c0_c0 pd-0 w-100 hover_yujianjingyingshujudaping_489_fd0_1_c1_c0_c0_c3_c0_c0_c0 a' :field-options="field_options_883340" data_source_type="1" chart_show_type="pie-ring" show_title="true" title_position="left" title_name="发起预约报价类型占比" :open_linkage="false" :link_chart="[]" :chart-option="chartOptions_random_4735">

                        </benben-pie-ring>


                      </a-col>


                      <a-col :xs="24" :md="12" :xl="6" :xxl="6">

                        <benben-pie-ring class='yujianjingyingshujudaping_651_random_fd0_1_c1_c0_c0_c3_c0_c0_c0 w-100' :field-options="field_options_374147" data_source_type="1" chart_show_type="pie-ring" show_title="true" title_position="left" title_name="接单成功报价类型占比" :chart-option="chartOptions_random_9802">

                        </benben-pie-ring>


                      </a-col>


                      <a-col :xs="24" :md="12" :xl="6" :xxl="6">

                        <benben-pie-ring class='yujianjingyingshujudaping_651_random_fd0_1_c1_c0_c0_c3_c0_c0_c0 w-100' :field-options="field_options_376302" data_source_type="1" chart_show_type="pie-ring" show_title="true" title_position="left" title_name="服务完成行业分类占比(次)" :chart-option="chartOptions_random_6002">

                        </benben-pie-ring>


                      </a-col>


                      <a-col :xs="24" :md="12" :xl="6" :xxl="6">

                        <benben-pie-ring class='yujianjingyingshujudaping_651_random_fd0_1_c1_c0_c0_c3_c0_c0_c0 w-100' :field-options="field_options_866575" data_source_type="1" chart_show_type="pie-ring" show_title="true" title_position="right" title_name="服务完成行业分类占比(金额)" :open_linkage="false" :link_chart="[]" :chart-option="chartOptions_random_2023">

                        </benben-pie-ring>


                      </a-col>


                    </a-row>


                  </div>

                </div>

                <a-row class="benben-grid   w-100" :gutter="[8,8]" type="flex">

                  <a-col :xs="24" :md="12" :xl="12" :xxl="12">
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_996_fd0_1_c1_c0_c1_c0_c0 w-100 bdr-16 position-relative">
                      <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                        <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">近7天预约成功数曲线</span>

                      </div>
                      <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240411/cb9152c53372d773b45b09f9c9ddab2b.png" />

                      <qiu-area-charts class='yujianjingyingshujudaping_757_random_fd0_1_c1_c0_c1_c0_c0_c2 w-100' :field-options="field_options_243486" data_source_type="1" chart_show_type="area_gradient_curve" type="area" :chart-option="chartOptions_random_8043">

                      </qiu-area-charts>


                    </div>

                  </a-col>


                  <a-col :xs="24" :md="12" :xl="12" :xxl="12">
                    <div class="flex flex-direction align-start yujianjingyingshujudaping_996_fd0_1_c1_c0_c1_c0_c0 w-100 bdr-16 position-relative">
                      <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                        <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">近7天全部收入曲线</span>

                      </div>
                      <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240411/cb9152c53372d773b45b09f9c9ddab2b.png" />

                      <qiu-area-charts class='yujianjingyingshujudaping_757_random_fd0_1_c1_c0_c1_c0_c0_c2 w-100' :field-options="field_options_863766" data_source_type="1" chart_show_type="area_gradient_curve" type="area" :chart-option="chartOptions_random_2053">

                      </qiu-area-charts>


                    </div>

                  </a-col>


                </a-row>


              </div>

            </a-col>


            <a-col :xs="24" :md="6" :xl="6" :xxl="6">
              <div class="flex  flex-wrap align-center yujianjingyingshujudaping_221_fd0_1_c0_c0 w-100">
                <div class="flex flex-direction align-start yujianjingyingshujudaping_621_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bdr-16 position-relative">
                  <div class="flex flex-direction flex-wrap align-start  w-100">
                    <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                      <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">师傅完成数排行</span>

                    </div>
                    <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png" />

                  </div>

                  <benben-bar-cross class='w-100 h-100' :field-options="field_options_829420" data_source_type="1" chart_show_type="bar-cross" show_title="false" title_position="left" title_name="标题" :is_morcolor="false" :theme_color="theme_color_1706" :chart-option="chartOptions_random_3900">

                  </benben-bar-cross>


                </div>
                <div class="flex flex-direction align-start yujianjingyingshujudaping_621_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bdr-16 position-relative">
                  <div class="flex flex-direction flex-wrap align-start  w-100">
                    <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                      <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">师傅完成金额排行</span>

                    </div>
                    <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png" />

                  </div>

                  <benben-bar-cross class='w-100 h-100' :field-options="field_options_879266" data_source_type="1" chart_show_type="bar-cross" show_title="false" title_position="left" title_name="标题" :is_morcolor="false" :theme_color="theme_color_8415" :chart-option="chartOptions_random_8904">

                  </benben-bar-cross>


                </div>
                <div class="flex flex-direction align-start yujianjingyingshujudaping_621_fd0_1_c0_c0_c0 w-100 bdr-16 position-relative">
                  <div class="flex flex-direction flex-wrap align-start  w-100">
                    <div class="flex align-center justify-between yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 w-100">
                      <span class="yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 f-c-fff t-20">拒单订单列表</span>

                    </div>
                    <img class='yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png" />

                  </div>

                  <big-screen-table class='w-100 h-100' :field-options="field_options_808817" data_source_type="1" chart_show_type="big_screen_table" show_title="false" title_position="left" title_name="" :show_num="4" play_type="one_num" num_width="10" num_shape="circle" num_name="序号" num_top="3" :show_sort="true" sort_order="desc" sort_field="create_time">

                  </big-screen-table>


                </div>

              </div>

            </a-col>


          </a-row>


          <benben-bar-cross class='w-100 h-100' :field-options="field_options_111341" data_source_type="1" chart_show_type="bar-cross" show_title="false" title_position="left" title_name="标题" :is_morcolor="false" :theme_color="theme_color_5280" :chart-option="chartOptions_random_6351">

          </benben-bar-cross>


        </div>

      </div>
    </div>
  </layout-bigscreen>
</template>
<script>
import {
  bigScreenMixins,
  receiveNew
} from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
import {
  receive,
  benbenSelectDiy,
  benbenFlexNumberBox,
  scrollList,
  treeSelect,
  simpleSelect,
  multipleSelect,
  cascaderForm,
  checkboxForm,
  switchForm,
  messageReply,
  rangePicker,
  handSignature,
  mixinAddTableItem,
  editorForm,
  qiunDataCharts,
  copyText,
  mixinTableItemChange,
  in_array,
  themeColorInit,
  getUrlKey,
  clearDataPass,
  isEmpty,
  treeEdit
} from '@/assets/diypaaspc/diy-pass-pc.js'
import {
  provinceForm
} from '@/assets/diypaaspc/province_area.js'
import request from '@/utils/request'
import * as echarts from 'echarts'
import 'echarts-gl'
import 'echarts-liquidfill'
import {
  mapdata
} from '@/assets/diypaaspc/mapdata.js'
import layoutBigscreen from "@/components/layoutBigscreen"
import {getShopTradeStatistics} from "@/api/statistic/index";
import {userSta} from "@/api/statistics/user";

export default {
  name: 'yujianjingyingshujudaping',
  components: {
    layoutBigscreen
  },
  mixins: [bigScreenMixins],
  data() {
    const themeColorConfig = {
      "presetApi": {
        "getClassifyOne": "",
        "getClassifyTow": "",
        "getClassifyShop": ""
      },
      "themeType": 0,
      "themeConfig": [{
        "colorConfig": ["#333333", "#666666", "#999999", "#ffffff", "#0052c7", "#F02325", "#FC9C3A", "#4DC777", "#F2CC98", "#F2CC66"],
        "bgColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#FC9fff", "#E6F333", "#E6F1FE", "linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)", "linear-gradient(180deg, #F5588E 0%, #F0403C 100%)", "linear-gradient(179deg, #FFD033 0%, #F4890E 100%)"],
        "bdColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#333333", "#666666", "#999999", "#dddddd", "#1178F0", "#F02325"]
      }]
    };
    receive(this);
    receiveNew(this);
    return {
      themeColorConfig,
      mapdata: mapdata,
      "theme_color_5280": ["#24cbff", "#9000ff", "#484cdc", "#711d8e", "#2d3c98", "#3f8bd8", "#2e33d1", "#1589ff", "#5c4ac9"],
      "chartOptions_random_6351": {
        "tooltip": {
          "show": true,
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "grid": {
          "left": "3%",
          "right": "6%",
          "bottom": "3%",
          "top": "6%",
          "containLabel": true
        },
        "barSetting": {
          "barWidth": 16,
          "markPoint": {
            "label": {
              "normal": {
                "textStyle": {
                  "color": "#fff",
                  "fontSize": 14,
                  "fontWeight": 400
                }
              }
            },
            "itemStyle": [],
            "data": [{
              "type": "max",
              "name": "最大值"
            }],
            "symbol": "pin",
            "symbolSize": 50
          },
          "label": {
            "normal": {
              "show": true,
              "position": "right",
              "fontSize": 16,
              "color": "#fff"
            }
          },
          "itemStyle": {
            "borderRadius": [5, 5, 5, 5]
          },
          "markLine": {
            "label": {
              "color": "#fff"
            },
            "symbol": "none",
            "lineStyle": {
              "type": "dashed"
            },
            "data": []
          }
        },
        "xAxis": {
          "type": "value",
          "axisTick": {
            "show": true
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400,
            "rotate": 0
          },
          "splitLine": {
            "show": false,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        },
        "yAxis": {
          "type": "category",
          "axisTick": {
            "show": false
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400
          },
          "splitLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        }
      },
      "field_options_111341": {
        "yAxis": {
          "data": ["美国", "中国", "印度", "巴西", "印度尼西亚", "世界"]
        },
        "series": [{
          "name": 2021,
          "type": "bar",
          "data": [1250000, 1100000, 850000, 420000, 350000, 5800000]
        }, {
          "name": 2022,
          "type": "bar",
          "data": [1350000, 1200000, 900000, 450000, 370000, 6100000]
        }]
      },
      "field_options_808817": {
        "columns": [{
          "name": "分组织",
          "prop": "subsys"
        }, {
          "name": "部门",
          "prop": "module"
        }, {
          "name": "业务组",
          "prop": "business"
        }, {
          "name": "姓名",
          "prop": "name"
        }, {
          "name": "销售额",
          "prop": "value",
          "accuracy": 1
        }, {
          "name": "地址",
          "prop": "url",
          "accuracy": 1
        }],
        "rows": [{
          "subsys": "北京总部",
          "module": "市场部",
          "business": "第一小分队",
          "name": "张三",
          "value": 6672389,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "北京总部",
          "module": "市场部",
          "business": "第一小分队",
          "name": "李四",
          "value": 7673456.78,
          "value_level": "green",
          "url": "http://www.baidu.com"
        }, {
          "subsys": "北京总部",
          "module": "市场二部",
          "business": "第二小分队",
          "name": "百度",
          "__showx_row_level": "red",
          "value": "<a href='http://www.baidu.com' target='_blank'>百度链接</a>",
          "value_ishtml": true,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "张伟",
          "value": 8967569,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "李静",
          "value": 5645657,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "完颜付",
          "value": 4999889,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "纳兰德",
          "value": 8878765,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售二部",
          "business": "突击小队",
          "name": "迪乌夫",
          "value": 7609878,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售二部",
          "business": "突击小队",
          "name": "南宫强",
          "value": 6786546,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售二部",
          "business": "突击小队",
          "name": "萨珊珊",
          "value": 3909786,
          "url": "http://www.baidu.com"
        }]
      },
      "theme_color_8415": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
      "chartOptions_random_8904": {
        "tooltip": {
          "show": true,
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "grid": {
          "left": "3%",
          "right": "6%",
          "bottom": "3%",
          "top": "6%",
          "containLabel": true
        },
        "barSetting": {
          "barWidth": 16,
          "markPoint": {
            "label": {
              "normal": {
                "textStyle": {
                  "color": "#fff",
                  "fontSize": 14,
                  "fontWeight": 400
                }
              }
            },
            "itemStyle": [],
            "data": [{
              "type": "max",
              "name": "最大值"
            }],
            "symbol": "pin",
            "symbolSize": 50
          },
          "label": {
            "normal": {
              "show": true,
              "position": "right",
              "fontSize": 16,
              "color": "#fff"
            }
          },
          "itemStyle": {
            "borderRadius": [5, 5, 5, 5]
          },
          "markLine": {
            "label": {
              "color": "#fff"
            },
            "symbol": "none",
            "lineStyle": {
              "type": "dashed"
            },
            "data": []
          }
        },
        "xAxis": {
          "type": "value",
          "axisTick": {
            "show": true
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400,
            "rotate": 0
          },
          "splitLine": {
            "show": false,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        },
        "yAxis": {
          "type": "category",
          "axisTick": {
            "show": false
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400
          },
          "splitLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        }
      },
      "field_options_879266": {
        "yAxis": {
          "data": ["美国", "中国", "印度", "巴西", "印度尼西亚", "世界"]
        },
        "series": [{
          "name": 2021,
          "type": "bar",
          "data": [1250000, 1100000, 850000, 420000, 350000, 5800000]
        }, {
          "name": 2022,
          "type": "bar",
          "data": [1350000, 1200000, 900000, 450000, 370000, 6100000]
        }]
      },
      "theme_color_1706": ["#3EDCE0", "#1A7EEF", "#8A59FA", "#FA577E", "#FBB26E"],
      "chartOptions_random_3900": {
        "tooltip": {
          "show": true,
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "grid": {
          "left": "3%",
          "right": "6%",
          "bottom": "3%",
          "top": "6%",
          "containLabel": true
        },
        "barSetting": {
          "barWidth": 16,
          "markPoint": {
            "label": {
              "normal": {
                "textStyle": {
                  "color": "#fff",
                  "fontSize": 14,
                  "fontWeight": 400
                }
              }
            },
            "itemStyle": [],
            "data": [{
              "type": "max",
              "name": "最大值"
            }],
            "symbol": "pin",
            "symbolSize": 50
          },
          "label": {
            "normal": {
              "show": true,
              "position": "right",
              "fontSize": 16,
              "color": "#fff"
            }
          },
          "itemStyle": {
            "borderRadius": [5, 5, 5, 5]
          },
          "markLine": {
            "label": {
              "color": "#fff"
            },
            "symbol": "none",
            "lineStyle": {
              "type": "dashed"
            },
            "data": []
          }
        },
        "xAxis": {
          "type": "value",
          "axisTick": {
            "show": true
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400,
            "rotate": 0
          },
          "splitLine": {
            "show": false,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        },
        "yAxis": {
          "type": "category",
          "axisTick": {
            "show": false
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400
          },
          "splitLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        }
      },
      "field_options_829420": {
        "yAxis": {
          "data": ["美国", "中国", "印度", "巴西", "印度尼西亚", "世界"]
        },
        "series": [{
          "name": 2021,
          "type": "bar",
          "data": [1250000, 1100000, 850000, 420000, 350000, 5800000]
        }, {
          "name": 2022,
          "type": "bar",
          "data": [1350000, 1200000, 900000, 450000, 370000, 6100000]
        }]
      },
      "chartOptions_random_2053": {
        "color": ["#1890FF", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4", "#ea7ccc"],
        "padding": [15, 15, 0, 15],
        "enableScroll": false,
        "legend": {
          "padding": 5,
          "fontSize": 13,
          "lineHeight": 11
        },
        "xAxis": {
          "disableGrid": true
        },
        "yAxis": {
          "gridType": "dash",
          "dashLength": 2
        },
        "extra": {
          "area": {
            "type": "curve",
            "opacity": 0.2,
            "addLine": true,
            "width": 2,
            "gradient": true,
            "activeType": "hollow"
          },
          "tooltip": {
            "bgOpacity": 0.7,
            "labelBgOpacity": 0.7,
            "borderOpacity": 0.7
          },
          "markLine": []
        },
        "animation": true,
        "duration": 1000,
        "timing": "easeOut",
        "dataLabel": true,
        "dataPointShape": true,
        "dataPointShapeType": "solid"
      },
      "field_options_863766": {
        "categories": [2018, 2019, 2020, 2021, 2022, 2023],
        "series": [{
          "name": "成交量A",
          "data": [35, 8, 25, 37, 4, 20]
        }, {
          "name": "成交量B",
          "data": [70, 40, 65, 100, 44, 68]
        }, {
          "name": "成交量C",
          "data": [100, 80, 95, 150, 112, 132]
        }]
      },
      "chartOptions_random_8043": {
        "color": ["#1890FF", "#91CB74", "#FAC858", "#EE6666", "#73C0DE", "#3CA272", "#FC8452", "#9A60B4", "#ea7ccc"],
        "padding": [15, 15, 0, 15],
        "enableScroll": false,
        "legend": {
          "padding": 5,
          "fontSize": 13,
          "lineHeight": 11
        },
        "xAxis": {
          "disableGrid": true
        },
        "yAxis": {
          "gridType": "dash",
          "dashLength": 2
        },
        "extra": {
          "area": {
            "type": "curve",
            "opacity": 0.2,
            "addLine": true,
            "width": 2,
            "gradient": true,
            "activeType": "hollow"
          },
          "tooltip": {
            "bgOpacity": 0.7,
            "labelBgOpacity": 0.7,
            "borderOpacity": 0.7
          },
          "markLine": []
        },
        "animation": true,
        "duration": 1000,
        "timing": "easeOut",
        "dataLabel": true,
        "dataPointShape": true,
        "dataPointShapeType": "solid"
      },
      "field_options_243486": {
        "categories": [2018, 2019, 2020, 2021, 2022, 2023],
        "series": [{
          "name": "成交量A",
          "data": [35, 8, 25, 37, 4, 20]
        }, {
          "name": "成交量B",
          "data": [70, 40, 65, 100, 44, 68]
        }, {
          "name": "成交量C",
          "data": [100, 80, 95, 150, 112, 132]
        }]
      },
      "chartOptions_random_2023": {
        "seriesSetting": {
          "center": ["50%", "50%"],
          "radius": ["30%", "50%"],
          "itemStyle": {
            "borderColor": "",
            "borderWidth": "",
            "borderRadius": ""
          },
          "startAngle": "",
          "type": "pie",
          "label": {
            "color": "#fff"
          }
        },
        "labelSetting": {
          "label": {
            "color": "#fff",
            "show": false,
            "emphasis": {
              "show": true,
              "textStyle": {
                "fontSize": 14,
                "color": "#fff"
              },
              "rich": {
                "a": {
                  "fontSize": 14
                }
              }
            }
          },
          "labelLine": {
            "show": true
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "tooltip": {
          "show": true,
          "autoToolTip": false,
          "trigger": "item",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        }
      },
      "field_options_866575": {
        "series": [{
          "data": [{
            "value": 1335,
            "name": "苹果"
          }, {
            "value": 1310,
            "name": "三星"
          }, {
            "value": 1234,
            "name": "华为"
          }, {
            "value": 1350,
            "name": "小米"
          }, {
            "value": 1548,
            "name": "oppo"
          }]
        }]
      },
      "chartOptions_random_6002": {
        "seriesSetting": {
          "center": ["50%", "50%"],
          "radius": ["30%", "50%"],
          "itemStyle": {
            "borderColor": "",
            "borderWidth": "",
            "borderRadius": ""
          },
          "startAngle": "",
          "type": "pie",
          "label": {
            "color": "#fff"
          }
        },
        "labelSetting": {
          "label": {
            "color": "#fff",
            "show": true,
            "emphasis": {
              "show": true,
              "textStyle": {
                "fontSize": 14,
                "color": "#fff"
              },
              "rich": {
                "a": {
                  "fontSize": 14
                }
              }
            }
          },
          "labelLine": {
            "show": true
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "tooltip": {
          "show": true,
          "autoToolTip": false,
          "trigger": "item",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        }
      },
      "field_options_376302": {
        "series": [{
          "data": [{
            "value": 1335,
            "name": "苹果"
          }, {
            "value": 1310,
            "name": "三星"
          }, {
            "value": 1234,
            "name": "华为"
          }, {
            "value": 1350,
            "name": "小米"
          }, {
            "value": 1548,
            "name": "oppo"
          }]
        }]
      },
      "chartOptions_random_9802": {
        "seriesSetting": {
          "center": ["50%", "50%"],
          "radius": ["30%", "50%"],
          "itemStyle": {
            "borderColor": "",
            "borderWidth": "",
            "borderRadius": ""
          },
          "startAngle": "",
          "type": "pie",
          "label": {
            "color": "#fff"
          }
        },
        "labelSetting": {
          "label": {
            "color": "#fff",
            "show": true,
            "emphasis": {
              "show": true,
              "textStyle": {
                "fontSize": 14,
                "color": "#fff"
              },
              "rich": {
                "a": {
                  "fontSize": 14
                }
              }
            }
          },
          "labelLine": {
            "show": true
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": "top"
        },
        "tooltip": {
          "show": true,
          "autoToolTip": false,
          "trigger": "item",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        }
      },
      "field_options_374147": {
        "series": [{
          "data": [{
            "value": 1335,
            "name": "苹果"
          }, {
            "value": 1310,
            "name": "三星"
          }, {
            "value": 1234,
            "name": "华为"
          }, {
            "value": 1350,
            "name": "小米"
          }, {
            "value": 1548,
            "name": "oppo"
          }]
        }]
      },
      "chartOptions_random_4735": {
        "seriesSetting": {
          "center": ["50%", "50%"],
          "radius": ["30%", "50%"],
          "itemStyle": {
            "borderColor": "",
            "borderWidth": "",
            "borderRadius": ""
          },
          "startAngle": "",
          "type": "pie",
          "label": {
            "color": "#fff"
          }
        },
        "labelSetting": {
          "label": {
            "color": "#fff",
            "show": true,
            "emphasis": {
              "show": true,
              "textStyle": {
                "fontSize": 14,
                "color": "#fff"
              },
              "rich": {
                "a": {
                  "fontSize": 14
                }
              }
            },
            "formatter": "{b}: {c}",
            "position": "outside"
          },
          "labelLine": {
            "show": true
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "tooltip": {
          "show": true,
          "autoToolTip": true,
          "trigger": "item",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        }
      },
      "field_options_883340": {
        "series": [{
          "data": [{
            "value": 1335,
            "name": "苹果"
          }, {
            "value": 1310,
            "name": "三星"
          }, {
            "value": 1234,
            "name": "华为"
          }, {
            "value": 1350,
            "name": "小米"
          }, {
            "value": 1548,
            "name": "oppo"
          }]
        }]
      },
      "field_options_494928": {
        "data": 49
      },
      "field_options_984204": {
        "data": 14
      },
      "field_options_571671": {
        "data": 77
      },
      "field_options_936238": {
        "data": 44
      },
      "field_options_310893": {
        "data": 133
      },
      "field_options_788678": {
        "data": 49
      },
      "field_options_965623": {
        "data": 14
      },
      "field_options_953521": {
        "data": 77
      },
      "field_options_988847": {
        "data": 44
      },
      "field_options_803063": {
        "data": 133
      },
      "field_options_947098": {
        "columns": [{
          "name": "分组织",
          "prop": "subsys"
        }, {
          "name": "部门",
          "prop": "module"
        }, {
          "name": "业务组",
          "prop": "business"
        }, {
          "name": "姓名",
          "prop": "name"
        }, {
          "name": "销售额",
          "prop": "value",
          "accuracy": 1
        }, {
          "name": "地址",
          "prop": "url",
          "accuracy": 1
        }],
        "rows": [{
          "subsys": "北京总部",
          "module": "市场部",
          "business": "第一小分队",
          "name": "张三",
          "value": 6672389,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "北京总部",
          "module": "市场部",
          "business": "第一小分队",
          "name": "李四",
          "value": 7673456.78,
          "value_level": "green",
          "url": "http://www.baidu.com"
        }, {
          "subsys": "北京总部",
          "module": "市场二部",
          "business": "第二小分队",
          "name": "百度",
          "__showx_row_level": "red",
          "value": "<a href='http://www.baidu.com' target='_blank'>百度链接</a>",
          "value_ishtml": true,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "张伟",
          "value": 8967569,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "李静",
          "value": 5645657,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "完颜付",
          "value": 4999889,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售部",
          "business": "第三小分队",
          "name": "纳兰德",
          "value": 8878765,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售二部",
          "business": "突击小队",
          "name": "迪乌夫",
          "value": 7609878,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售二部",
          "business": "突击小队",
          "name": "南宫强",
          "value": 6786546,
          "url": "http://www.baidu.com"
        }, {
          "subsys": "上海分部",
          "module": "销售二部",
          "business": "突击小队",
          "name": "萨珊珊",
          "value": 3909786,
          "url": "http://www.baidu.com"
        }]
      },
      "theme_color_7163": ["#24cbff", "#9000ff", "#484cdc", "#711d8e", "#2d3c98", "#3f8bd8", "#2e33d1", "#1589ff", "#5c4ac9"],
      "chartOptions_random_5150": {
        "tooltip": {
          "show": true,
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "grid": {
          "left": "3%",
          "right": "6%",
          "bottom": "3%",
          "top": "6%",
          "containLabel": true
        },
        "barSetting": {
          "barWidth": 16,
          "markPoint": {
            "label": {
              "normal": {
                "textStyle": {
                  "color": "#fff",
                  "fontSize": 14,
                  "fontWeight": 400
                }
              }
            },
            "itemStyle": [],
            "data": [{
              "type": "max",
              "name": "最大值"
            }],
            "symbol": "pin",
            "symbolSize": 50
          },
          "label": {
            "normal": {
              "show": true,
              "position": "right",
              "fontSize": 16,
              "color": "#fff"
            }
          },
          "itemStyle": {
            "borderRadius": [5, 5, 5, 5]
          },
          "markLine": {
            "label": {
              "color": "#fff"
            },
            "symbol": "none",
            "lineStyle": {
              "type": "dashed"
            },
            "data": []
          }
        },
        "xAxis": {
          "type": "value",
          "axisTick": {
            "show": true
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400,
            "rotate": 0
          },
          "splitLine": {
            "show": false,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        },
        "yAxis": {
          "type": "category",
          "axisTick": {
            "show": false
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400
          },
          "splitLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        }
      },
      "field_options_602307": {
        "yAxis": {
          "data": ["美国", "中国", "印度", "巴西", "印度尼西亚", "世界"]
        },
        "series": [{
          "name": 2021,
          "type": "bar",
          "data": [1250000, 1100000, 850000, 420000, 350000, 5800000]
        }, {
          "name": 2022,
          "type": "bar",
          "data": [1350000, 1200000, 900000, 450000, 370000, 6100000]
        }]
      },
      "theme_color_9213": ["#3EDCE0", "#1A7EEF", "#8A59FA", "#FA577E", "#FBB26E"],
      "chartOptions_random_8300": {
        "tooltip": {
          "show": true,
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow"
          },
          "textStyle": {
            "color": "inherit",
            "fontSize": 14
          }
        },
        "legend": {
          "type": "scroll",
          "textStyle": {
            "color": "#fff"
          },
          "show": false,
          "orient": "horizontal",
          "left": "center",
          "top": ""
        },
        "grid": {
          "left": "3%",
          "right": "6%",
          "bottom": "3%",
          "top": "6%",
          "containLabel": true
        },
        "barSetting": {
          "barWidth": 16,
          "markPoint": {
            "label": {
              "normal": {
                "textStyle": {
                  "color": "#fff",
                  "fontSize": 14,
                  "fontWeight": 400
                }
              }
            },
            "itemStyle": [],
            "data": [{
              "type": "max",
              "name": "最大值"
            }],
            "symbol": "pin",
            "symbolSize": 50
          },
          "label": {
            "normal": {
              "show": true,
              "position": "right",
              "fontSize": 16,
              "color": "#fff"
            }
          },
          "itemStyle": {
            "borderRadius": [5, 5, 5, 5]
          },
          "markLine": {
            "label": {
              "color": "#fff"
            },
            "symbol": "none",
            "lineStyle": {
              "type": "dashed"
            },
            "data": []
          }
        },
        "xAxis": {
          "type": "value",
          "axisTick": {
            "show": true
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400,
            "rotate": 0
          },
          "splitLine": {
            "show": false,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        },
        "yAxis": {
          "type": "category",
          "axisTick": {
            "show": false
          },
          "axisLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          },
          "axisLabel": {
            "show": true,
            "color": "#fff",
            "fontSize": 12,
            "fontWeight": 400
          },
          "splitLine": {
            "show": true,
            "lineStyle": {
              "color": "#6E7079"
            }
          }
        }
      },
      "field_options_377306": {
        "yAxis": {
          "data": ["美国", "中国", "印度", "巴西", "印度尼西亚", "世界"]
        },
        "series": [{
          "name": 2021,
          "type": "bar",
          "data": [1250000, 1100000, 850000, 420000, 350000, 5800000]
        }, {
          "name": 2022,
          "type": "bar",
          "data": [1350000, 1200000, 900000, 450000, 370000, 6100000]
        }]
      },
      "isFullScreen": false,
      "big_screen_global_query": {
        "screen_global_time_range_type": "5",
        "screen_global_time_custom_time": "",
        "screen_global_dept": "",
        "screen_global_user": ""
      },
      "saizhuge_api_loaded": false,
      "school_info": {},
      "weather_info": {},
      "weather_data": [{
        "name": "晴",
        "code": "0",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
      }, {
        "name": "夜晚晴",
        "code": "1",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
      }, {
        "name": "晴",
        "code": "2",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
      }, {
        "name": "夜晚晴",
        "code": "3",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
      }, {
        "name": "多云",
        "code": "4",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/937ea42d4d54677a960419fc926d2308.png"
      }, {
        "name": "晴间多云",
        "code": "5",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
      }, {
        "name": "晴间多云",
        "code": "6",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
      }, {
        "name": "大部多云",
        "code": "7",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8c1710ce88d626dad374865cc5cc285d.png"
      }, {
        "name": "大部多云",
        "code": "8",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8e47c4a733b6ea39aa94ea362bc942fa.png"
      }, {
        "name": "阴",
        "code": "9",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/b8a945d068a4c968e5c05e023a67571f.png"
      }, {
        "name": "阵雨",
        "code": "10",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2987ff71ec8f90fdffa1c0114e13b1f9.png"
      }, {
        "name": "雷阵雨",
        "code": "11",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/751a274ee37d368cd45471edc5b35411.png"
      }, {
        "name": "雷阵雨伴有冰雹",
        "code": "12",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/2c7657970388a04e29049a23a0046c56.png"
      }, {
        "name": "小雨",
        "code": "13",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/6b02916ef905c0f100e3e6d4bf4c4ff0.png"
      }, {
        "name": "中雨",
        "code": "14",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/cc26fd0d1cda78eda4b53d85718b8803.png"
      }, {
        "name": "大雨",
        "code": "15",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/1598c140199a349d9ec4aed4482f0cf1.png"
      }, {
        "name": "暴雨",
        "code": "16",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
      }, {
        "name": "大暴雨",
        "code": "17",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b460fe42bb0e8dcbc177b5d6ef5b3c30.png"
      }, {
        "name": "特大暴雨",
        "code": "18",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
      }, {
        "name": "冻雨",
        "code": "19",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/121096065da289cc9ebf23c778c8a4e8.png"
      }, {
        "name": "雨夹雪",
        "code": "20",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d9c47f9707616842680ba38e1c8e4d43.png"
      }, {
        "name": "阵雪",
        "code": "21",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/af6e554f62f546c76b3b495df7f36eb2.png"
      }, {
        "name": "小雪",
        "code": "22",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/71744d3bd3230b10f5d09666a76657ea.png"
      }, {
        "name": "中雪",
        "code": "23",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a29d1ac31de2a2cdaecfb4c579cdf928.png"
      }, {
        "name": "大雪",
        "code": "24",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/62145c7aea6a3e65c5f1dc8d84f5c92d.png"
      }, {
        "name": "暴雪",
        "code": "25",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/50946c87ed7c0e4c471d7cb0310115c3.png"
      }, {
        "name": "浮尘",
        "code": "26",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/46258a78adc3acf03d0186836e89b798.png"
      }, {
        "name": "扬沙",
        "code": "27",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a2440c63509d48eb1fa45804c6476f7d.png"
      }, {
        "name": "沙尘暴",
        "code": "28",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/9a80471d8001ea814aa4206d3feda602.png"
      }, {
        "name": "强沙尘暴",
        "code": "29",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/da4066fc0584850d72ec402894765b2d.png"
      }, {
        "name": "雾",
        "code": "30",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/4cf7128b075acfd65af6ea175f7240ce.png"
      }, {
        "name": "霾",
        "code": "31",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/c6325f4ef718e9aef9dbff86e2d28817.png"
      }, {
        "name": "风",
        "code": "32",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/dccb4227577c4f0e51c6b9b16fa75af1.png"
      }, {
        "name": "大风",
        "code": "33",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b1d9445881a4a9d0b1471f831d3800c8.png"
      }, {
        "name": "飓风",
        "code": "34",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d58120ad96b2b4df9f4ffb35dc07c3c7.png"
      }, {
        "name": "热带风暴",
        "code": "35",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/3ca919f2ae75739b3196460dfffdd405.png"
      }, {
        "name": "龙卷风",
        "code": "36",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
      }, {
        "name": "冷",
        "code": "37",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
      }, {
        "name": "热",
        "code": "38",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d33c81b9f8772998d9bba7d3ea52acb0.png"
      }, {
        "name": "未知",
        "code": "99",
        "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/db353a99b557f85968a262210c69f0d7.png"
      }],
      "viewSource": "PC",
      "big_screen_global_config": {
        "is_screen_global_time": false,
        "is_screen_global_dept": false,
        "is_screen_global_user": false
      },
      "designWidth": 1920,
      "designHeight": 1080,
      "calculateStyles": {},
      "screenWidth": window.innerWidth,
      "screenHeight": window.innerHeight,
      "timerW": false,
      "timerH": false
    };

  },
  filters: {},
  created() {
    if (getUrlKey('viewSource')) {
      this.viewSource = getUrlKey('viewSource');
    }
    this.get_diy_api_page();
  },
  mounted() {

    let that = this;
    window.onresize = () => {
      that.screenWidth = that.$refs.antdVue.offsetWidth
      that.screenHeight = that.$refs.antdVue.offsetHeight
      that.handleResize();
    }
    this.$nextTick(() => {
      that.handleResize();
    })
  },
  computed: {

  },
  watch: {
    screenWidth(val) {
      if (!this.timerW) {
        let that = this;
        // that.screenWidth = val;
        this.timerW = true;
        that.handleResize();
        setTimeout(function() {
          that.timerW = false;
        }, 400)
      }
    },
    screenHeight(val) {
      if (!this.timerH) {
        let that = this;
        // that.screenHeight = val;
        this.timerH = true;
        that.handleResize();
        setTimeout(function() {
          that.timerH = false;
        }, 400)
      }
    }
  },
  methods: {
    copyText,
    mixinTableItemChange,
    in_array,
    themeColorInit,
    isEmpty,
    //统一获取自定义接口
    get_diy_api_page() {
      getShopTradeStatistics().then((res) => {
        //店铺订单数量排行
        this.field_options_377306 = res.data.shopOrderNumList;
        this.field_options_602307 = res.data.shopOrderMoneyList;
      });

    },
    handleResize() {
      let that = this;
      this.$nextTick(() => {
        that.screenWidth = that.$refs.antdVue.offsetWidth
        that.screenHeight = that.$refs.antdVue.offsetHeight
        let screenWidth = that.screenWidth;
        let screenHeight = that.screenHeight;
        let scale = Math.min(screenWidth / this.designWidth, screenHeight / this.designHeight);
        let horizontalOffset = (screenWidth - this.designWidth * scale) / 2;
        that.calculateStyles = {
          transformOrigin: 'top left',
          transform: `translateX(${horizontalOffset}px)  scale(${scale}) `,
        };
      });
    }

  }
}
</script>
<style lang="less" scoped>
@import 'https://zhongtai.zhongbenruanjian.com/static/diypaaspc/css/diy-pass-pc.css';
@import '../../assets/diypaaspc/diy-pass-big-screen.css';
@import '../../assets/diypaaspc/library-ant-design-vue.css';

.antdVue {
  position: relative;
  width: 100%;
  width: 1920px;
  height: 1080px;
  background: none;
  background-size: 100% auto !important;
}

.zoom_bg_color {
  background: rgba(2, 8, 15, 0);
}

#antdVue .yujianjingyingshujudaping_981_random_flex_0 {
  background-position: 0px 10px;
}

#antdVue .yujianjingyingshujudaping_757_random_fd0_1_c1_c0_c1_c0_c0_c2 {
  height: 400px;
}

#antdVue .yujianjingyingshujudaping_996_fd0_1_c1_c0_c1_c0_c0 {
  background: rgba(38, 95, 255, .2);
  height: 455px;
  padding: 16px;
}

#antdVue .hover_yujianjingyingshujudaping_489_fd0_1_c1_c0_c0_c3_c0_c0_c0:hover {
  margin: 0px 0px 0px 0px;
  border-radius: 16px 16px 16px 16px;
}

#antdVue .yujianjingyingshujudaping_651_random_fd0_1_c1_c0_c0_c3_c0_c0_c0 {
  height: 200px;
  --chart-title-size: 16px;
  --chart-title-top: 0px;
  --chart-top: 0px;
}

#antdVue .yujianjingyingshujudaping_542_fd0_1_c1_c0_c0_c1_c0_c1_c1 {
  font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
  margin: 0px 0px 1px 0px;
}

#antdVue .yujianjingyingshujudaping_642_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 {
  font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
}

#antdVue .yujianjingyingshujudaping_691_fd0_1_c1_c0_c0_c1_c0_c0 {
  font-family: PingFang SC, PingFang SC;
}

#antdVue .yujianjingyingshujudaping_404_fd0_1_c1_c0_c0_c1_c0 {
  background: rgba(38, 95, 255, .1);
  width: 140px;
  padding: 12px 16px 12px 16px;
  border-radius: 8px;
  margin: 0px 9px 0px 0px;
}

#antdVue .yujianjingyingshujudaping_141_fd0_1_c1_c0_c0_c1 {
  height: 88px;
  margin: 0px 0px 16px 0px;
}

#antdVue .yujianjingyingshujudaping_820_fd0_1_c1_c0_c0_c0_c0_c1 {
  width: 12px;
  height: 6px;
}

#antdVue .yujianjingyingshujudaping_856_fd0_1_c1_c0_c0_c0_c0_c0 {
  margin: 0px 5px 0px 0px;
}

#antdVue .yujianjingyingshujudaping_979_random_fd0_1_c1_c0_c0_c0 {
  height: 50px;
  --diadog-bg: #050E17;
}

#antdVue .yujianjingyingshujudaping_999_fd0_1_c1_c0_c0 {
  background: rgba(38, 95, 255, .1);
  height: 430px;
  padding: 16px;
}

#antdVue .yujianjingyingshujudaping_335_fd0_1_c0_c0_c0_c0_c1 {
  height: 4px;
  border-radius: 0px 0px 0px 0px;
}

#antdVue .yujianjingyingshujudaping_986_fd0_1_c0_c0_c0_c0_c0_c0 {
  font-weight: 800;
  font-family: Source Han Sans SC, Source Han Sans SC;
}

#antdVue .yujianjingyingshujudaping_291_fd0_1_c0_c0_c0_c0_c0 {
  margin: 0px 0px 016px 0px;
}

#antdVue .yujianjingyingshujudaping_621_fd0_1_c0_c0_c0 {
  background: rgba(38, 95, 255, .2);
  height: 288px;
  padding: 16px;
}

#antdVue .yujianjingyingshujudaping_221_fd0_1_c0_c0 {
  margin: 0px 0px 0px 5px;
}

#antdVue .yujianjingyingshujudaping_370_random_fd0_0_c5 {
  width: 70px;
  height: 70px;
  --full-screen-color: rgba(255, 255, 255, 1);
  --full-screen-width: 35px;
  --full-screen-height: 35px;
  top: 28px;
  right: 100px;
  z-index: 99;
}

#antdVue .yujianjingyingshujudaping_600_random_fd0_0_c4_c1 {
  color: rgba(255, 255, 255, 1);
}

#antdVue .yujianjingyingshujudaping_573_fd0_0_c4_c0 {
  width: 32px;
  height: 32px;
  border-radius: 0px 0px 0px 0px;
  margin: 0px 8px 0px 0px;
}

#antdVue .yujianjingyingshujudaping_608_fd0_0_c4 {
  width: 300px;
  top: 38px;
  right: 180px;
  height: 50px;
}

#antdVue .yujianjingyingshujudaping_135_fd0_0_c3 {
  width: 48px;
  height: 48px;
  border-radius: 0px 0px 0px 0px;
  margin: 0px 0px 0px 8px;
}

#antdVue .yujianjingyingshujudaping_976_fd0_0_c1 {
  width: 48px;
  height: 48px;
  margin: 0px 8px 0px 0px;
}

#antdVue .yujianjingyingshujudaping_651_fd0_0_c0_c3 {
  margin: 0px 0px 0px 8px;
  line-height: 10px;
}

#antdVue .yujianjingyingshujudaping_340_fd0_0_c0_c2 {
  background: linear-gradient(180deg, rgba(216, 226, 255, 0) 0%, #E3EAFF 49%, rgba(216, 226, 255, 0) 100%);
  width: 2px;
  height: 16px;
  margin: 0px 0px 0px 8px;
}

#antdVue .yujianjingyingshujudaping_796_fd0_0_c0_c1 {
  margin: 0px 0px 0px 8px;
}

#antdVue .yujianjingyingshujudaping_425_fd0_0_c0_c0 {
  width: 32px;
  height: 32px;
  border-radius: 0px 0px 0px 0px;
}

#antdVue .yujianjingyingshujudaping_883_fd0_0_c0 {
  top: 38px;
  left: 82px;
  height: 50px;
}

#antdVue .yujianjingyingshujudaping_683_fd0_0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/95867b2fe8e71f9cd1cf14259ed09824.png) no-repeat;
  font-size: 48px;
  height: 135px;
  font-weight: 800;
}

.zoom_bg_color {
  background: url('https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240218/28580720a4073072604131817b3e36d2.png') center center / 100% 100% no-repeat !important;

}
</style>